<template>
  <div data-app>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <h2 class="color-h2-project font-weight-bold">Tipologías</h2>
        <p class="pt-3">Selecciona la tipología de tu interés y cotiza</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6" v-for="(model, i) in models" :key="i">
        <div id="tip-web" class="col card-model d-none d-sm-block">
          <img v-if="model.medias?.full_url" class="mx-auto d-flex justify-content-center img-card-model"
            :src="model.medias?.full_url" alt="model" />
          <div class="col">
            <span class="d-block" style="font-size: 0.9rem">{{ model.property.total_area }} m<sup>2</sup></span>
            <span class="d-block" style="font-size: 0.9rem">{{ model.property.bedrooms }} Dormitorios y
              {{ model.property.bathrooms }} Baño - {{ model.model }}</span>
          </div>
          <div class="py-1 col">
            <button @click="selectedModel(model)" class="btn btn-block btn-form-contact-1"
              style="height: 35px !important">
              Cotizar
            </button>
          </div>
          <div v-show="keyReserve && keyReserve.api_key && keyReserve.secret_key" class="py-1 col">
            <a :href="url + '/reservar/' + model.model" class="btn btn-block btn-form-contact-1"
              style="height: 35px !important">Reservar</a>
          </div>
        </div>

        <div id="tip-mobile" class="col card-model d-sm-none">
          <div class="row">
            <div class="col-auto d-flex justify-content-center align-items-center">
              <img v-if="model.medias?.full_url" class="img-card-model" :src="model.medias?.full_url" alt="model" />
            </div>
            <div class="col">
              <span class="d-block" style="font-size: 0.9rem">{{ model.property.total_area }} m<sup>2</sup></span>
              <span class="d-block" style="font-size: 0.9rem">{{ model.property.bedrooms }} Dormitorios y
                {{ model.property.bathrooms }} Baño - {{ model.model }}</span>
              <button @click="selectedModel(model)"
                class="mt-2 btn btn-block btn-form-contact-1 d-flex align-items-center justify-content-center"
                style="height: 25px !important">
                Cotizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-quote @closeModal="closeModal" :project="project" :showModal="openModal" :model="modelSelected">
    </modal-quote>
  </div>
</template>

<script>
import ModalQuote from "./ModalQuote";

export default {
  name: "QuoteSection2",
  components: {
    ModalQuote,
  },
  props: {
    models: Array,
    project: Object,
    project_id: Number,
    keyReserve: Object,
  },
  data: () => ({
    openModal: false,
    modelSelected: [],
    url: window.location.href,
  }),
  computed: {},
  methods: {
    selectedModel(model) {
      this.modelSelected = model;
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
  },
};
</script>

<style scoped>
.img-card-model {
  height: 15rem;
}

@media (max-width: 575px) {
  .img-card-model {
    height: 5.5rem;
  }
}

.card-model {
  border-radius: 16px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
}

#tip-web a:hover {
  color: white !important;
}
</style>
